import { connect } from 'react-redux';

const RenderWithPermission = ({ permissions, permission, children, fallback = null }) =>
  permissions.indexOf(permission) !== -1 ? children : fallback;

function mapStateToProps(state) {
  return {
    permissions: state.brewery.role.permissions
  };
}

export default connect(mapStateToProps)(RenderWithPermission);



// WEBPACK FOOTER //
// ./src/containers/renderWithPermission/renderWithPermission.jsx